import { CashFlowExpenseFareItem } from "bus/cash/types/cashFlowExpenseFare";

export const initValue: CashFlowExpenseFareItem = {
  comment: '',
  date: '',
  sum: 0,
  cashFlowAccount: null,
  cashFlowItemId: null
};